"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (error) {
  // all error messages will be appended with: "Please contact your payment provider for assistance."

  if (!error) {
    return undefined;
  }

  if (error === "Too Many Requests") {
    return "We're sorry! It looks like there are too many payment attemps being made. Please wait for a few minutes and try again.";
  }
  if (error === "Invalid customer info" || error === "Invalid request payload input") {
    return "Could not save changes. Please update your billing details and try again.";
  }

  if (typeof error === "string") {
    return error;
  }

  switch (error) {
    case "USER_ALREADY_SUBSCRIBED":
      return "You already seem to have an active subscription. Please navigate to the Megascans library.";
    case "PAYMENT_TRANSACTION_FAILED":
    case "PAYMENT_METHOD_CREATION_FAILED":
      return "There was a problem processing your payment; please double check your payment information and try again.";
    case "SUBSCRIPTION_UPDATE_FAILED":
      return "Failed to update payment method associated with an active subscription.";
    case "INVALID_CUSTOMER_INFO":
      return "Could not save changes. Please update your billing details and try again.";

    default:
      return "We're sorry! We encountered an unknown error while trying to process your payment.";
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/paymentErrorMessage.js
// module id = 438
// module chunks = 0